var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHM(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 462.93 415.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 207.58,
    x2: 462.93,
    y2: 207.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#faa61a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M455.81,181L366.65,26.57c-9.49-16.44-27.04-26.57-46.03-26.57H142.31c-18.99,0-36.53,10.13-46.03,26.57L7.12,181c-9.49,16.44-9.49,36.7,0,53.15l89.16,154.43c9.49,16.44,27.04,26.57,46.03,26.57h178.32c18.99,0,36.53-10.13,46.03-26.57l89.16-154.43c9.49-16.44,9.49-36.7,0-53.15Zm-107.16,153.01c0,2.97-2.41,5.37-5.37,5.37h-21.28c-19.18,0-34.73-15.55-34.73-34.73v-53.32c0-9.82-7.96-17.78-17.78-17.78h-76.67c-9.61,0-17.4,7.79-17.4,17.4v53.32c0,19.39-15.72,35.11-35.11,35.11h-21.28c-2.97,0-5.37-2.41-5.37-5.37V81.13c0-2.97,2.41-5.37,5.37-5.37h21.28c19.39,0,35.11,15.72,35.11,35.11v53.32c0,7.53,6.11,13.64,13.64,13.64h84.19c7.74,0,14.02-6.28,14.02-14.02v-53.32c0-19.18,15.55-34.73,34.73-34.73h21.28c2.97,0,5.37,2.41,5.37,5.37v252.88Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHM);
export default __webpack_public_path__ + "static/media/h-m.a7644f8e2ec7af1933c556d812068b16.svg";
export { ForwardRef as ReactComponent };